export const app = {
  default: {
    locale: 'ru',
    lsKey: 'user-data',
  },
};
